<template>
  <div class="d-flex flex-fill">
    <div v-if="mode === 'view'" class="d-flex flex-fill">{{ data == null ? '-' : data }}</div>
    <div v-if="mode === 'edit' || mode === 'create'" class="d-flex flex-fill">
      <input
        v-if="show"
        ref="input"
        id="debtor"
        type="number"
        v-on:keydown="onKeyDown"
        v-model="model"
        @change="onValueChanged($event.target.value)"
        class="form-control"
        :placeholder="'بدهکار'"
      >
    </div>
  </div>
</template>

<script>
import EventBus from "../_framework/bus.js";
import * as $ from "jquery";
export default {
  name: "debtor",
  props: {
    data: null,
    header: null,
    headerKey: null,
    mode: null,
    placeholder: null,
    type: null,
    row: null
  },
  //   ["data", "header", "headerKey", "mode", "placeholder", "type", "row"],
  data() {
    return {
      show: true,
      model: null,
      lastValue: ""
    };
  },
  methods: {
    onValueChanged(val) {
      this.$emit("dataChanged", this.headerKey, val);
    },
    onKeyDown(event) {
      this.onValueChanged(event.target.value);
      EventBus.$emit("debtorChange", event);
      if (this.type === "number" && event.key === "e") {
        event.preventDefault();
        return;
      }
      this.$nextTick(() => {
        if (event.target.value === this.lastValue) {
          return;
        }
        this.lastValue = event.target.value;
      });
    }
  },
  mounted() {
    EventBus.$on("onResetHeaderFormsValue", () => {
      $(this.$refs.input).val("");
      this.$emit("dataChanged", this.headerKey, "");
    });
    EventBus.$on("creditorChange", e => {
      $(this.$refs.input).val("");
      this.$emit("dataChanged", this.headerKey, "");
      if (e.key === "Enter") {
        EventBus.$emit("onPressEnter", this.row);
      }
    });
  },
  created() {},
  computed: {
    value() {
      if (
        this.header.formatCurrency !== undefined &&
        this.header.formatCurrency
      ) {
        return this.$options.filters.formatCurrency(this.data);
      }

      if (
        this.header.formatGregorianDateToJalaali !== undefined &&
        this.header.formatGregorianDateToJalaali
      ) {
        return this.$options.filters.formatGregorianDateToJalaali(this.data);
      }

      return this.data;
    }
  },
  watch: {
    mode(val) {
      if (val === "edit") {
        this.model =
          typeof this.data === "string"
            ? JSON.parse(JSON.stringify(this.data.replace(/,/g, ""))) * 1
            : this.data;
        this.onValueChanged(this.model);
      }
    }
  }
};
</script>

<style scoped>
#debtor::placeholder {
  text-align: center;
}
</style>